import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, setDisplayName } from 'recompose';
import { debounce, get } from 'lodash';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import { withStyles } from '@material-ui/core/styles';
import ExpandIcon from '@material-ui/icons/KeyboardArrowDown';
import CollapseIcon from '@material-ui/icons/KeyboardArrowUp';
import Sort from '@material-ui/icons/UnfoldMore';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Redirect } from "react-router-dom";
import {
  dispatchRestMaker,
  clearCartLocalStorage,
  getOrganizationUID
} from 'helpers/utils';
import {
  UnauthorizedHeader,
  injectIntl,
  SearchComponent,
  Avatar,
  SidebarItems,
  AddVendorButton,
} from 'components';
import qs from 'qs';
import sellersActions from 'redux/sellers/actions';
import Sidebar from 'components/App/Sidebar';
import { CardBioContent, CardCover, CardLogo } from 'components/Card';
import { withTracker } from 'components/Tracker';
import immutableToJS from 'helpers/immutableToJS';
import { getPublicInfo } from 'redux/marketPlace/actions';
import { selectState } from 'redux/selectors';
import CardDetails from './CardDetails';
import { accessTokenSelector } from 'redux/auth/selectors';
import LocalShipping from '@material-ui/icons/LocalShipping';
import { Popover, PopoverBody } from 'reactstrap';
import { Link } from 'react-router-dom';
import { isMobile } from 'helpers/detect-mobile';

const styles = () => ({
  bio: { maxHeight: '50px', scrollY: 'auto' },
});

class PublicProfile extends Component {
  static contextTypes = {
    currentUser: PropTypes.shape({}),
    isConsumer: PropTypes.bool,
    currentMember: PropTypes.shape({}),
    isDistributor: PropTypes.bool,
    isFarmer: PropTypes.bool,
  };

  static propTypes = {
	accessToken: PropTypes.string,
    history: PropTypes.shape({}),
    permissions: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
    })),
    location: PropTypes.shape({}).isRequired,
    publicInfo: PropTypes.shape({}).isRequired,
    publicInfoRequesting: PropTypes.bool,
    createSeller: PropTypes.func.isRequired,
    formatMessage: PropTypes.func.isRequired,
    getPublicInfo: PropTypes.func.isRequired,
    sellers: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
    })).isRequired,
  };

  static defaultProps = {
    accessToken: null,
    publicInfoRequesting: false,
    history: {},
    permissions: [],
  };

  state = {
    searchText: '',
    sortDirection: '',
    connectVendor: false,
    distributorsPopup: false,
    distributorsMobilePopup: false,
  };

  componentWillMount() {
    const { isConsumer } = this.context;
    const { location } = this.props;
    const { connect } = qs.parse(location.search.slice(1));
    if (connect && JSON.parse(connect) === true) {
      this.setState({ connectVendor: JSON.parse(connect) });
    }
    const organizationUID = this.extractOrganizationUID(this.props);
    organizationUID && this.props.getPublicInfo({ organizationUID, isConsumer, onSuccess: this.onSuccessPublicInfo });
  }

  componentWillReceiveProps(nextProps) {
    const organizationUID = this.extractOrganizationUID(nextProps);
    if (this.extractOrganizationUID(this.props) !== organizationUID) {
      organizationUID && nextProps.getPublicInfo({ organizationUID });
    }
  }

  onCancelSearch = () => this.setState({ searchText: '' });

  onSearchText = value => this.setState({ searchText: value });

  onSortTimeStamp = () => {
    const { sortDirection } = this.state;
    const nextSortDirection = !sortDirection ? 'asc' : {
      asc: 'desc',
      desc: '',
    }[sortDirection];
    this.setState({ sortDirection: nextSortDirection });
  }

  onSuccessPublicInfo = () => {
    const { currentUser, isConsumer } = this.context;
    const { publicInfo, history, location } = this.props;
    const { connectVendor } = this.state;

    if (publicInfo && publicInfo.account && publicInfo.account.email && currentUser && isConsumer && connectVendor === true) {
      const vendor = { email: publicInfo.account.email };
      this.addVendor(vendor);
    } else if (publicInfo && publicInfo.account && !connect) {
      history.push(location.pathname);
    }
  }

  extractOrganizationUID = (props) => {
    const { location } = props;
    return location.pathname.split('@')[1];
  }

  addVendor = (data) => {
    const { history, location } = this.props;
    this.props.createSeller({
      ...data,
      onSuccess: () => {
        history.push(location.pathname);
      },
    });
  }
  handleLogout = () => {
    memoryDB.tokenInfo = JSON.stringify({ data: {} });
    clearCartLocalStorage();
    window.location = '/';
  };

  renderDistributorConnections = (connection) => {
    const { formatMessage } = this.props;
    const { buyersCount, sellersCount } = connection;

    return (
      <Fragment>
        <div style={{fontSize: 18}}>
          {`${formatMessage('Farms')}: ${sellersCount}`}
        </div>
        <div style={{fontSize: 18, marginRight:30}}>
          {`${formatMessage('Customers')}: ${buyersCount}`}
        </div>
      </Fragment>
    );
  }

  renderFarmConnections = (connection) => {
    const { isConsumer } = this.context;
    const { formatMessage } = this.props;
    const { distributorsPopup } = this.state;
    const { consumersCount, restaurantsCount, distributors } = connection;

    const distributorsOpens = distributors.filter(dist => !dist.buyer.profile.isOff);

    return (
      <Fragment>
        <div className="d-flex" style={{fontSize: 18}}>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              this.setState({ distributorsPopup: true });
            }}
            id="distributors"
            style= {{visibility: distributorsOpens.length > 0 ? 'visible' : 'hidden' }}
          >
            <LocalShipping style={{ fontSize: 35, marginRight: '10px' }} />
            {`${formatMessage('Distributors')}: `}
            {distributorsOpens.length}
          </a>

        </div>
        <div className="d-flex" style={{fontSize: 18}} >
          {`${formatMessage('Customers')}: ${isConsumer ? consumersCount : restaurantsCount + distributors.length}`}
        </div>
        <Popover
          className="distributors-popover"
          placement="bottom"
          isOpen={distributorsPopup}
          toggle={() => this.setState({ distributorsPopup: false })}
          target="distributors"
        >
          <PopoverBody>
            {distributorsOpens.map(d => (
              <div key={d.id}>
                <Link
                  to={`+${getOrganizationUID(d.buyer.profile.companyName)}`}
                  onClick={() => this.setState({ distributorsPopup: false })}
                >
                  {d.buyer.profile.companyName}
                </Link>
              </div>
            ))}
          </PopoverBody>
        </Popover>
      </Fragment>
    );
  }

  render() {
    const { formatMessage, publicInfo, publicInfoRequesting, history,
      accessToken,
      permissions,
      setScrollTop, sellers, ...props } = this.props;
    if (!currentUser && window.location.pathname.includes('+')) {
      return <Redirect to={window.location.pathname.replace('+', 'shop@')} />
    }

    const { searchText, sortDirection } = this.state;
    const { currentUser, isConsumer, isDistributor, isFarmer, currentMember } = this.context;
    // const { id, account: { email, profile: { companyName, logoUrl } } } = currentUser.organizations[0];
    const account = currentUser && currentUser.organizations && currentUser.organizations.length > 0 && currentUser.organizations[0].account;
    const email = account && account.email;
    const profile = account && account.profile;
    const companyName = profile && profile.companyName;
    const logoUrl = profile && profile.logoUrl;
    const clickable = true;

    let deactivated = false;
    if (accessToken && !currentMember && currentUser) {
      const {
        account: {
          profile: {
            firstName,
            lastName,
            mobile,
            companyName,
            addresses,
          },
        },
      } = currentUser || { account: { profile: { addresses: [{}] } } };
      const { address, city, state, zipcode } = addresses && addresses.length ? addresses[0] : {};

      if (!firstName || !lastName || !mobile || !companyName
        || !address || !city || !state || !zipcode) {
        if (get(currentUser, 'account.currentRoleId')) {
          deactivated = true;
        }
      }
    }

    // set nav-bar items for each mode.
    let filterOption = 'inBuyer';
    if (isFarmer) {
      filterOption = 'inSeller';
    } else if (isDistributor) {
      filterOption = 'inDistributor';
    }
    let items = permissions.filter(permission => permission[filterOption]);
    if (currentMember && currentMember.permissions) {
      items = items.filter(permission =>
        permission.isDivider || currentMember.permissions.find(({ id }) => permission.id === id),
      );
      items = items.filter((permission, index) =>
        !(permission.isDivider && (index === 0 || items[index - 1].isDivider)),
      );
    }
    if (!currentUser.role) {
      items = [];
    }
    items = items.map(permission => (
      permission.isDivider
        ? { divider: true }
        : {
          name: formatMessage(permission.name),
          url: `/${permission.frontendUrl}`,
        }
    ));
    items.push({ space: true });
    items.push({ divider: true });
    items.push(
      {
        handleClick: this.handleLogout,
        icon: 'fa fa-sign-out',
        name: formatMessage('Logout'),
      },
    );
    if (!publicInfo.account && !publicInfoRequesting) {
      return (
        <Fragment>
          <UnauthorizedHeader headerTitle={formatMessage('Not found')} />
          <Card
            style={{
              height: '100vh',
              overflowY: 'auto',
              paddingBottom: 100,
            }}
          />
        </Fragment>
      );
    }

    const avatar = (
      <CardLogo
        image={get(publicInfo, 'account.profile.logoUrl')}
        imageEditable={false}
        info={get(publicInfo, 'account.profile')}
      />
    );

    const avatarCurrentUser = (
      <div>
        {(email || companyName) && (
          <Avatar
            highlighted
            clickable={clickable}
            src={logoUrl}
            key={email}
            fullName={companyName || email}
          />
        )}
      </div>
    );

    const currentCoverImageUrl = get(publicInfo, 'account.profile.coverImageUrl');
    const currentRoleId = get(publicInfo, 'account.currentRoleId');
    const cardCover = (
      <CardCover
        image={currentCoverImageUrl}
        imageEditable={false}
        info={get(publicInfo, 'account')}
      />
    );
    const iconDirectionForOrder = {
      asc: <CollapseIcon style={styles.iconStyle} />,
      desc: <ExpandIcon style={styles.iconStyle} />,
    }[sortDirection] || <Sort style={styles.iconStyle} />;

    return (
      <Fragment>
        <SearchComponent
          cancelSearch={this.onCancelSearch}
          placeholder={formatMessage('Search ') + get(publicInfo, 'account.profile.companyName') + formatMessage(' Items')}
          search={debounce(this.onSearchText, 500)}
          searchText={searchText}
        />
        <UnauthorizedHeader
          headerTitle={(
            <Fragment>
              <div className='d-md-down-none'>
                <span style={{ fontSize: 22, verticalAlign: 'middle' }}>
                  {publicInfoRequesting
                    ? formatMessage('Loading ...')
                    : get(publicInfo, 'account.profile.companyName') || ''
                  }
                </span>
              </div>
            </Fragment>
          )}
          avatar={avatarCurrentUser}
          accessToken={accessToken}
          isMarketplaceStore
        />
        {accessToken && (
          <SidebarItems
            items={items}
          />
        )}
        {publicInfoRequesting ? (
          <div className="main-progress">
            <CircularProgress />
          </div>
        ) : (
          <Card
            className={`public-profile ${publicInfoRequesting ? 'loading' : ''} loading-enabled`}
            style={{
              height: '100vh',
              overflowY: 'auto',
              paddingBottom: 100,
            }}
          >
            <CardHeader
              avatar={avatar}
              title={
                <div className="d-flex" style={{justifyContent:'space-between', alignItems:'center'}}>
                  <div style={{fontSize: isMobile ? 16 : 18}}>
                    <span>{get(publicInfo, 'account.profile.companyName')} - </span>
                    <span> {get(publicInfo, 'account.profile.addresses.0.city')}, {get(publicInfo, 'account.profile.addresses.0.state')}</span>
                  </div>
                  {!isMobile && 
                    <React.Fragment>
                      <div>
                        <AddVendorButton vendorAccount={get(publicInfo, 'account')} />
                      </div>
                      { 
                        currentRoleId === 4 && !publicInfoRequesting &&
                        this.renderFarmConnections(publicInfo.connection)
                      }
                      {
                        currentRoleId === 3 && !publicInfoRequesting &&
                        this.renderDistributorConnections(publicInfo.connection)
                      }
                    </React.Fragment>                   
                  }
                
                </div>
              }
            />
            <CardContent>
              <CardDetails
                account={get(publicInfo, 'account')}
                details={publicInfo.products}
                iconDirectionForOrder={iconDirectionForOrder}
                onSortTimeStamp={this.onSortTimeStamp}
                requesting={publicInfoRequesting}
                searchText={searchText}
                sortDirection={sortDirection}
                connection={publicInfo.connection}
                currentRoleId={currentRoleId}
                isMobile={isMobile}
                accessToken={accessToken}
                sellers={sellers}
              />
            </CardContent>
          </Card>
        )}
        {accessToken && (
          <Sidebar
            currentMember={currentMember}
            currentUser={currentUser}
            history={history}
            deactivated={deactivated}
            {...props}
          />
        )}
      </Fragment>
    );
  }
}
/* istanbul ignore next */
const mapStateToProps = state => ({
  ...selectState('marketPlace', 'publicInfo')(state),
  accessToken: accessTokenSelector(state),
  ...selectState('options', 'permissions')(state, 'permissions'),
  ...selectState('buyers', 'buyers')(state, 'buyers'),
  ...selectState('sellers', 'sellers')(state, 'sellers'),
});

/* istanbul ignore next */
const mapDispatchToProps = dispatch => ({
  getPublicInfo: payload => dispatch(getPublicInfo(payload)),
  ...dispatchRestMaker([
    [sellersActions, 'seller'],
  ])(dispatch),
});

export default compose(
  setDisplayName('PublicProfile'),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withStyles(styles),
  immutableToJS,
  injectIntl,
  withTracker,
)(PublicProfile);

